import React from "react";

const PendingReaderConfirmModal = ({
  show,
  selectedLanguage,
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  return (
    // <div className="modalCus" id="myModal" style={{ zIndex: 1080 }}>
    //   <div className="modal-dialog modal-dialog-centered">
    //     <div className="modal-content">
    //       <div className="modal-body">
    //         <div className="d-flex justify-content-center flex-column mb-3 text-center my-2">
    //           <div className="mb-3">
    //             <span
    //               className="material-icons text-warning"
    //               style={{ fontSize: "64px" }}>
    //               warning_amber
    //             </span>
    //           </div>
    //           <p className="w-100 f-w550 mb-2" style={{ display: "content" }}>
    //             One or more selected readers have already requested access to
    //             this RPD. Click Confirm to approve the requests and add the new
    //             readers to the authorized readers list, or click Cancel to
    //             return to the previous screen.
    //           </p>
    //         </div>
    //         <div className="d-flex justify-content-center gap-3 mb-2">
    //           <button
    //             type="button"
    //             className="btn btn-danger px-4"
    //             onClick={() => onCancel()}>
    //             {selectedLanguage?.LstLanguageCodes?.UI_Cancel ?? "Cancel"}
    //           </button>
    //           <button
    //             type="button"
    //             className="btn btn-primary px-4"
    //             onClick={() => onConfirm()}>
    //             Confirm
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div
      className="modal"
      id="MoveFolder"
      style={{ display: "block", backgroundColor: "#8080801c", zIndex: 1080 }}>
      <div className="modal-dialog modal-dialog-centered modal-customelg">
        <div className="modal-content">
          <div className="modal-header pb-1">
            <h4
              className="d-flex align-items-center text-danger fw-bold "
              htmlFor="">
              {selectedLanguage.LstLanguageCodes.UI_Update}
            </h4>
          </div>
          <div
            className="d-flex justify-content-center flex-column mb-3 text-center mt-2"
            style={{ marginTop: "20px" }}>
            <p className="w-100 f-w550 mb-2 font-18 p-2 " style={{ display: "content" }}>
              {selectedLanguage?.LstLanguageCodes?.UI_OneOrMoreSelectedReaders}
            </p>
          </div>
          <div className="d-flex justify-content-center gap-3 mb-2">
            <button
              type="button"
              className="btn btn-danger px-4"
              onClick={() => onCancel()}>
              {selectedLanguage?.LstLanguageCodes?.UI_Cancel ?? "Cancel"}
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={() => onConfirm()}>
              {selectedLanguage?.LstLanguageCodes?.UI_Confirm ?? "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingReaderConfirmModal;
